import React, { useEffect, useRef, useState } from "react";

interface UseIntersectionObserverReturn {
  containerRef: React.MutableRefObject<null>;
  isSticky: boolean;
}

export const useIntersectionObserver = (): UseIntersectionObserverReturn => {
  const containerRef = useRef(null);
  const [isSticky, setIsSticky] = useState(true);

  const callbackFunction: IntersectionObserverCallback = (e) => {
    const [entry] = e;
    setIsSticky(!entry.isIntersecting);
  };

  useEffect(() => {
    let observer: IntersectionObserver;
    const observeRef = containerRef.current;
    if (observeRef) {
      observer = new IntersectionObserver(callbackFunction, {
        threshold: 1.0,
      });
      observer.observe(observeRef);
    }
    return () => {
      if (containerRef.current === null && observer) {
        observer.disconnect();
      }
    };
  }, [containerRef]);

  return { containerRef, isSticky };
};
